var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "editor-row customize-editor-minimize data-items" },
    [
      _c("div", { staticClass: "editor-row-title" }, [_vm._v("Default Value")]),
      _vm._v(" "),
      _c("TiptapEditor", {
        attrs: {
          placeholder: "Input Text",
          "show-attributes": true,
          "show-emoji": false,
          "automation-mode": "",
        },
        model: {
          value: _vm.clone.default.value,
          callback: function ($$v) {
            _vm.$set(_vm.clone.default, "value", $$v)
          },
          expression: "clone.default.value",
        },
      }),
      _vm._v(" "),
      _vm._m(0),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("small", { staticClass: "description" }, [
      _vm._v("\n        JSONPath get more info from "),
      _c(
        "a",
        {
          attrs: {
            href: "https://goessner.net/articles/JsonPath/",
            target: "_blank",
          },
        },
        [_vm._v("here")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }